// extracted by mini-css-extract-plugin
export default {"playerWrapper":"Player_playerWrapper__ePxlY","aspectRatioBox":"Player_aspectRatioBox__jDn4B","plyr":"Player_plyr__RAjuZ"};